/**
 * Web destination for a budgetRebalanceRecommendation alert.
 * Mirrors mobile/app/utils/rebalanceAlertDestination.ts and the native router.
 * Returns null when the alert is not a rebalance alert.
 */

const LARGE_EXPENSE_REASONS = new Set([
  'daily_allowance_threshold',
  'large_uncategorized_transaction',
]);

function nonempty(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function rebalanceAlertDestination(metadata) {
  if (!metadata || metadata.action !== 'budgetRebalanceRecommendation') return null;

  const budgetId = nonempty(metadata.budgetId);
  const transactionId = nonempty(metadata.transactionId) || nonempty(metadata.triggerTransactionId);

  if (LARGE_EXPENSE_REASONS.has(metadata.primaryReason)) {
    if (transactionId) return { type: 'transaction', transactionId };
    return { type: 'transactions' };
  }

  if (budgetId) return { type: 'budgetReview', budgetId };
  return { type: 'budgets' };
}

function rebalanceCtaLabel(metadata) {
  if (!metadata || metadata.action !== 'budgetRebalanceRecommendation') return null;
  if (!LARGE_EXPENSE_REASONS.has(metadata.primaryReason)) return null;
  return 'View transaction';
}

export { rebalanceAlertDestination, rebalanceCtaLabel };
